import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { XmlEditorContext } from './code/xmlEditorContext.class';

/** @dynamic */
@Injectable({
  providedIn: 'root'
})
export class AngularXmlEditorService {
  private contexts = new Map<string, XmlEditorContext>();

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  getNewEditorContextId(): string {
    let no = 0;
    while (this.contexts.has(no.toString())) {
      no++;
    }
    return no.toString();
  }

  getEditorContext(contextId: string): XmlEditorContext {
    let context = this.contexts.get(contextId);
    if (context === undefined) {
      context = new XmlEditorContext(this._document);
      this.contexts.set(contextId, context);
    }
    return context;
  }

  disposeEditorContext(contextId: string) {
    this.contexts.delete(contextId);
  }
}
